<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="sendBranchWindow.visible"
      :title="sendBranchWindow.title"
      width="360px"
      :close-on-click-modal="false"
    >
      <el-form label-width="96px" label-position="right">
        <el-form-item v-for="(item, index) in sendBranchWindow.items" :key="index" :label="item.userLabel">
          <cargo-user-select
            :method-params="{officeId: sendBranchWindow.officeId, category:'role', shape: item.shape}"
            :default-value="item.userId||''"
            @change="p=>{item.userId=p.value;userId_changeHandler(item)}"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="enterSendHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="sendBranchWindow.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { LOG_SE_SEA_BOOKING, LOG_SI_SEA_BOOKING, LOG_AE_AIR_BOOKING, LOG_RE_RAILWAY_BOOKING } from '@/class/cargo/model/parameters/SystemConstants'
import { Company } from '@/class/model/mdm/Company'
import { Office } from '@/class/model/sys/Office'
import { cache } from '@/utils/cacheManager'
import { getUserDefaultDepartment } from '@/api/user'
import { getOfficeByUuid } from '@/api/office'
import { queryCompany } from '@/api/company'
import { checkingConsignationJob, saveCloneJob as saveCloneJobSE } from '@/api/seaExport/seaExportJob'
import { saveCloneJobFunc as saveCloneJobSI } from '@/api/SeaImport/seaImportJob'
import { saveEntrustedByBranch as saveEntrustedByBranchAE } from '@/api/AirExport/airExportJob'
import { saveCloneJob as saveCloneJobRE } from '@/api/railwayExport/reBooking'
import { saveCloneJobFunc as saveCloneJobIE } from '@/api/integratedJob/ieBooking'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'

export default {
  name: 'TenantEntrustWindow',
  components: {
    cargoUserSelect
  },
  data() {
    return {
      isSop: false,
      tenantInstruction: {
        uuid: '',
        platformInstructionCode: '',
        allowMultipleOperations: false
      },
      batchOperate: false,
      batchOperateTip: false,
      selectType: '', // 海出：客服/操作，海进：客服/操作，空运：航线，铁路：客服，综合物流：操作
      required: false, // 是否必填
      jobs: [],
      lob: '',
      isCopySellingCharge: false,
      overwriteJobRefNoBySEconvertSI: false,
      chargeSyncNeedConfirm: false,
      sendBranchWindow: {
        visible: false,
        entrustData: [], // 委托数据
        title: '',
        officeId: null,
        items: []
      },
      queryCompanyCache: new Map() // queryCompany接口缓存
    }
  },
  computed: {
    location() {
      switch (this.lob) {
        case 'SE':
          return LOG_SE_SEA_BOOKING.code
        case 'SI':
          return LOG_SI_SEA_BOOKING.code
        case 'AE':
          return LOG_AE_AIR_BOOKING.code
        case 'RE':
          return LOG_RE_RAILWAY_BOOKING.code
      }
      return ''
    }
  },
  methods: {
    // UI自定义使用
    onShowOfUI(uiInstruction, jobs) {
      this.isSop = false
      this.tenantInstruction.uuid = uiInstruction.tenantInstructionUuid
      this.tenantInstruction.platformInstructionCode = uiInstruction.platformInstructionRuleCode
      this.tenantInstruction.allowMultipleOperations = uiInstruction.allowMultipleOperations || false
      if (uiInstruction.instructionRuleJson) {
        this.batchOperate = uiInstruction.instructionRuleJson.batchOperate || false
        this.batchOperateTip = uiInstruction.instructionRuleJson.batchOperateTip || false
      } else {
        this.batchOperate = false
        this.batchOperateTip = false
      }
      if (uiInstruction.instructionParamJson) {
        this.selectType = uiInstruction.instructionParamJson.SelectType || ''
        this.required = uiInstruction.instructionParamJson.required?.toLowerCase() === 'true' || false
      } else {
        this.selectType = ''
        this.required = false
      }
      this.jobs = jobs
      this.lob = jobs[0].lob
      switch (this.tenantInstruction.platformInstructionCode) {
        case SystemConstants.PLATFORM_INSTRUCTION_CODE_SAME_TENANT_CROSS_DELEGATION.code:
          this.showEntrustWindow()
          break
      }
    },
    // SOP面板使用
    onShowOfSOP(sopInstruction, jobs) {
      this.isSop = true
      this.tenantInstruction.uuid = sopInstruction.uuid
      this.tenantInstruction.platformInstructionCode = sopInstruction.platformInstructionCode
      this.tenantInstruction.allowMultipleOperations = sopInstruction.allowMultipleOperations || false
      if (sopInstruction.instructionRuleJson) {
        this.batchOperate = sopInstruction.instructionRuleJson.batchOperate || false
        this.batchOperateTip = sopInstruction.instructionRuleJson.batchOperateTip || false
      } else {
        this.batchOperate = false
        this.batchOperateTip = false
      }
      if (sopInstruction.instructionParamJson) {
        this.selectType = sopInstruction.instructionParamJson.SelectType || ''
        this.required = sopInstruction.instructionParamJson.required?.toLowerCase() === 'true' || false
      } else {
        this.selectType = ''
        this.required = false
      }
      this.jobs = jobs
      this.lob = jobs[0].lob
      switch (this.tenantInstruction.platformInstructionCode) {
        case SystemConstants.PLATFORM_INSTRUCTION_CODE_SAME_TENANT_CROSS_DELEGATION.code:
          this.showEntrustWindow()
          break
      }
    },
    async showEntrustWindow() {
      if (this.jobs.length > 1) {
        if (this.batchOperate) {
          if (this.batchOperateTip) {
            const isOk = await this.$confirm(this.$t('SystemMaintenance.AreWantToPerformOperation'), this.$t('common.tips.prompt'), {
              confirmButtonText: this.$t('common.btn.ok'),
              cancelButtonText: this.$t('common.btn.cancel'),
              type: 'warning',
              closeOnClickModal: false
            }).then(() => true).catch(() => false)
            if (!isOk) {
              return
            }
          }
        } else {
          this.$message.warning(this.$t('SystemMaintenance.PleaseSelectOneJob'))
          return
        }
      }
      this.isCopySellingCharge = Number(cache.config.get('isCopySellingCharge')) === 1
      this.overwriteJobRefNoBySEconvertSI = Number(cache.config.get('OverwriteJobRefNoBySEconvertSI')) === 1
      this.chargeSyncNeedConfirm = Number(cache.config.get('ChargeSyncNeedConfirm')) === 1
      let cmpFieldName = 'bookingAgent'
      if (this.lob === 'SI') {
        cmpFieldName = 'exChangeAgent'
      } else if (this.lob === 'RE') {
        cmpFieldName = 'forwardingAgent'
      }
      const jobGroup = new Map()
      for (const job of this.jobs) {
        if (!job[cmpFieldName]) {
          continue
        }
        if (jobGroup.has(job[cmpFieldName])) {
          jobGroup.get(job[cmpFieldName]).push(job)
        } else {
          jobGroup.set(job[cmpFieldName], [job])
        }
      }
      const entrustData = []
      for (const [cmpIdx, jobs] of jobGroup) {
        const company = await Company.getCompanyById(cmpIdx)
        if (company && company.linkedBranchId > 0) {
          const office = await Office.getOfficeById(company.linkedBranchId)
          if (office) {
            const availableJobs = jobs.filter(job => company.linkedBranchId != job.opOffice && !job.relatedJob)
            if (availableJobs.length > 0) {
              entrustData.push({ company, office, jobs: availableJobs })
            }
          }
        }
      }
      if (entrustData.length === 0) {
        this.$message.warning(this.$t('SystemMaintenance.NoBusinessCanBeEntrusted'))
        return
      }
      this.sendBranchWindow.entrustData = entrustData
      if (entrustData.length === 1) {
        const office = entrustData[0].office
        this.sendBranchWindow.title = office.chineseName
        this.sendBranchWindow.officeId = office.officeId
      } else {
        this.sendBranchWindow.title = ''
        this.sendBranchWindow.officeId = null
      }
      this.sendBranchWindow.items = []
      switch (this.lob) {
        case 'SE': {
          const typeArr = this.selectType.split(',')
          for (const type of typeArr) {
            const item = { userId: 0, departmentId: 0, departmentOfficeId: 0 }
            if (type === '操作') {
              item.shape = 'op'
              item.userLabel = this.$t('SeaExport.Operation')
            } else {
              item.shape = 'csr'
              item.userLabel = this.$t('SeaExport.CustomerService')
            }
            this.sendBranchWindow.items.push(item)
          }
          break
        }
        case 'SI': {
          const item = { userId: 0, departmentId: 0, departmentOfficeId: 0 }
          if (type === '操作') {
            item.shape = 'op'
            item.userLabel = this.$t('SeaExport.Operation')
          } else {
            item.shape = 'csr'
            item.userLabel = this.$t('SeaExport.CustomerService')
          }
          this.sendBranchWindow.items.push(item)
          break
        }
        case 'AE': {
          const item = { userId: 0, departmentId: 0, departmentOfficeId: 0 }
          item.shape = 'airline'
          item.userLabel = this.$t('queryJob.route')
          this.sendBranchWindow.items.push(item)
          break
        }
        case 'RE': {
          const item = { userId: 0, departmentId: 0, departmentOfficeId: 0 }
          item.shape = 'csr'
          item.userLabel = this.$t('SeaExport.CustomerService')
          this.sendBranchWindow.items.push(item)
          break
        }
        case 'IE': {
          const item = { userId: 0, departmentId: 0, departmentOfficeId: 0 }
          item.shape = 'op'
          item.userLabel = this.$t('SeaExport.Operation')
          this.sendBranchWindow.items.push(item)
          break
        }
      }
      this.sendBranchWindow.visible = true
      this.queryCompanyCache.clear()
    },
    // 岗位change事件
    async userId_changeHandler(item) {
      const userId = item.userId
      if (userId > 0) {
        if (item.shape === 'csr') {
          await getUserDefaultDepartment({
            category: 'role',
            shape: 'csr',
            userId: userId
          }).then(res => this.getDefaultCsrResult(res, item))
        } else if (item.shape === 'op') {
          const officeId = this.sendBranchWindow.officeId
          if (officeId) {
            await getUserDefaultDepartment({
              category: 'role',
              shape: 'op',
              userId: userId,
              officeId
            }).then(res => this.getDefaultDeptResult(res, item))
          } else {
            await getUserDefaultDepartment({
              category: 'role',
              shape: 'op',
              userId: userId
            }).then(res => this.getDefaultDeptResult(res, item))
          }
        } else if (item.shape === 'airline') {
          await getUserDefaultDepartment({
            category: 'role',
            shape: 'airline',
            userId: userId
          }).then(res => this.getDefaultDeptResult(res, item))
        }
      } else {
        item.departmentId = 0
        item.departmentOfficeId = 0
      }
    },
    // 客服部门
    async getDefaultCsrResult(event, item) {
      const dep = event.data
      if (dep) {
        item.departmentId = dep.departmentId
        if (dep.officeUuid) {
          await getOfficeByUuid(dep.officeUuid).then(res => this.officeLoadHandler(res, item))
        } else {
          this.officeLoadHandler({ data: dep.office }, item)
        }
      } else {
        item.departmentId = 0
        item.departmentOfficeId = 0
      }
    },
    // 加载office后更新业务的岗位分公司
    officeLoadHandler(event, item) {
      const office = event.data
      if (office) {
        item.departmentOfficeId = office.officeId
      } else {
        item.departmentOfficeId = 0
      }
    },
    // 岗位部门
    getDefaultDeptResult(event, item) {
      const dep = event.data
      if (dep) {
        item.departmentId = dep.departmentId
      } else {
        item.departmentId = 0
      }
      item.departmentOfficeId = 0
    },
    enterSendHandler() {
      if (this.required) {
        for (const item of this.sendBranchWindow.items) {
          if (!item.userId) {
            this.$message.warning(this.$t('SystemMaintenance.PleaseSelect0', [item.userLabel]))
            return
          }
        }
      }
      this.sendBranchWindow.visible = false
      this.executeBatchTask()
    },
    async executeBatchTask() {
      /* 构建通用参数 */
      const item = {}
      if (this.lob === 'SE') {
        item.deptId = this.$store.getters.currentDeptId
        item.branchId = this.$store.getters.currentOfficeId
        item.anyStr = this.sendBranchWindow.items[0].shape // shape
        item.anyBool = this.isCopySellingCharge
        item.anyInteger = this.sendBranchWindow.items[0].departmentId
        item.anyInteger1 = this.sendBranchWindow.items[0].departmentOfficeId
        item.anyInteger2 = this.sendBranchWindow.items[0].userId
        // item.anyInteger3 = this.partner.cmpIdx
        // item.anyInteger4 = this.sendBranchWindow.office.officeId
        // item.anyStr1 = this.job.uuid
        item.anyBool1 = this.overwriteJobRefNoBySEconvertSI
        item.anyBool2 = this.chargeSyncNeedConfirm
        if (this.sendBranchWindow.items.length > 1) {
          const item2 = this.sendBranchWindow.items[1]
          item.anyStr2 = item2.shape // shape
          item.anyInteger5 = item2.departmentId // departmentId
          item.anyInteger6 = item2.departmentOfficeId // departmentOfficeId
          item.anyInteger7 = item2.userId // userId
        }
      } else if (this.lob === 'SI') {
        item.deptId = this.$store.getters.currentDeptId
        item.branchId = this.$store.getters.currentOfficeId
        item.anyStr = this.sendBranchWindow.items[0].shape // shape
        item.anyBool = this.isCopySellingCharge
        item.anyInteger = this.sendBranchWindow.items[0].departmentId
        item.anyInteger1 = this.sendBranchWindow.items[0].departmentOfficeId
        item.anyInteger2 = this.sendBranchWindow.items[0].userId
        // item.anyInteger3 = this.partner.cmpIdx
        // item.anyInteger4 = this.sendBranchWindow.office.officeId
        // item.anyStr1 = this.job.uuid
      } else if (this.lob === 'AE') {
        // item.jobUuid = this.job.uuid
        item.currentDeptId = this.$store.getters.currentDeptId
        item.currentOfficeId = this.$store.getters.currentOfficeId
        item.shape = 'airline' // shape
        item.userId = this.sendBranchWindow.items[0].userId
        item.userDepartmentId = this.sendBranchWindow.items[0].departmentId
        // item.bookingAgent = this.partner.cmpIdx
        // item.linkedBranchId = this.sendBranchWindow.office.officeId
        item.copySellingCharge = this.isCopySellingCharge
      } else if (this.lob === 'RE') {
        item.deptId = this.$store.getters.currentDeptId
        item.branchId = this.$store.getters.currentOfficeId
        item.anyStr = 'csr' // shape
        item.anyBool = this.isCopySellingCharge
        item.anyBool2 = this.chargeSyncNeedConfirm
        item.anyInteger = this.sendBranchWindow.items[0].departmentId
        item.anyInteger1 = this.sendBranchWindow.items[0].departmentOfficeId
        item.anyInteger2 = this.sendBranchWindow.items[0].userId
        // item.anyInteger3 = this.sendBranchWindow.cmpIdx // cmpIdx
        // item.anyInteger4 = this.sendBranchWindow.office.officeId
        // item.anyStr1 = this.currentRow.uuid
      } else if (this.lob === 'IE') {
        item.deptId = this.$store.getters.currentDeptId
        item.branchId = this.$store.getters.currentOfficeId
        item.anyBool = this.isCopySellingCharge
        item.anyBool2 = this.chargeSyncNeedConfirm
        item.anyStr = 'op' // shape
        item.anyInteger = this.sendBranchWindow.items[0].departmentId
        item.anyInteger1 = this.sendBranchWindow.items[0].departmentOfficeId
        item.anyInteger2 = this.sendBranchWindow.items[0].userId
        // item.anyInteger3 = this.sendBranchWindow.partner.cmpIdx
        // item.anyInteger4 = this.sendBranchWindow.office.officeId
        // item.anyStr1 = this.job.uuid
      }
      item.location = this.location

      const ajaxResult = []
      for (const { office, jobs } of this.sendBranchWindow.entrustData) {
        for (const job of jobs) {
          ajaxResult.push(this.executeSingleTask(item, office, job))
        }
      }
      const loading = getLoading4Cxt(this.$parent)
      try {
        await Promise.all(ajaxResult)
        this.$message.success(this.$t('Message.SuccessfullySent'))
      } finally {
        this.$emit('instructionCallback', { platformInstructionCode: this.tenantInstruction.platformInstructionCode })
        loading.close()
      }
    },
    async executeSingleTask(params, office, job) {
      if (this.lob === 'SE') {
        await this.executeSingleTaskSE(params, office, job)
      } else if (this.lob === 'SI') {
        await this.executeSingleTaskSI(params, office, job)
      } else if (this.lob === 'AE') {
        await this.executeSingleTaskAE(params, office, job)
      } else if (this.lob === 'RE') {
        await this.executeSingleTaskRE(params, office, job)
      } else if (this.lob === 'IE') {
        await this.executeSingleTaskIE(params, office, job)
      }
    },
    async executeSingleTaskSE(params, office, job) {
      let res = await checkingConsignationJob(job.uuid)
      if (res.data !== 1) {
        return
      }
      // 检索属于订舱代理所属分公司的合作伙伴ID
      res = await this.queryCompany(job.opOffice)
      if (!res.data || res.data.length === 0) {
        return
      }
      const partner = res.data[0]
      params = { ...params }
      params.anyInteger3 = partner.cmpIdx
      params.anyInteger4 = office.officeId
      params.anyStr1 = job.uuid
      await saveCloneJobSE(params)
    },
    async executeSingleTaskSI(params, office, job) {
      let res = await checkingConsignationJob(job.uuid)
      if (res.data !== 1) {
        return
      }
      // 检索属于订舱代理所属分公司的合作伙伴ID
      res = await this.queryCompany(job.opOffice)
      if (!res.data || res.data.length === 0) {
        return
      }
      const partner = res.data[0]
      params = { ...params }
      params.anyInteger3 = partner.cmpIdx
      params.anyInteger4 = office.officeId
      params.anyStr1 = job.uuid
      await saveCloneJobSI(params)
    },
    async queryCompany(linkedBranchId) {
      if (this.queryCompanyCache.has(linkedBranchId)) {
        return this.queryCompanyCache.get(linkedBranchId)
      }
      const res = await queryCompany(1, linkedBranchId)
      this.queryCompanyCache.set(linkedBranchId, res)
      return res
    },
    async executeSingleTaskAE(params, office, job) {
      // 检索属于订舱代理所属分公司的合作伙伴ID
      const res = await this.queryCompany(job.opOffice)
      if (!res.data || res.data.length === 0) {
        return
      }
      const partner = res.data[0]
      params = { ...params }
      params.jobUuid = job.uuid
      params.bookingAgent = partner.cmpIdx
      params.linkedBranchId = office.officeId
      await saveEntrustedByBranchAE(params)
    },
    async executeSingleTaskRE(params, office, job) {
      // 检索属于发运代理所属分公司的合作伙伴ID
      const res = await this.queryCompany(job.opOffice)
      if (!res.data || res.data.length === 0) {
        return
      }
      const partner = res.data[0]
      params = { ...params }
      params.anyInteger3 = partner.cmpIdx
      params.anyInteger4 = office.officeId
      params.anyStr1 = job.uuid
      await saveCloneJobRE(params)
    },
    async executeSingleTaskIE(params, office, job) {
      let res = await checkingConsignationJob(job.uuid)
      if (res.data !== 1) {
        return
      }
      // 检索属于订舱代理所属分公司的合作伙伴ID
      res = await this.queryCompany(job.opOffice)
      if (!res.data || res.data.length === 0) {
        return
      }
      const partner = res.data[0]
      params = { ...params }
      params.anyInteger3 = partner.cmpIdx
      params.anyInteger4 = office.officeId
      params.anyStr1 = job.uuid
      await saveCloneJobIE(params)
    }
  }
}
</script>
